import isbot from 'isbot';
import qs from 'qs';

import { priceWithCommas } from '../../utils/commonHelper';
import { addNumberDelimiterForPrice } from '../../utils/stringUtil';
import { inChinaIcpHost } from '../../utils/pathHelper';
import {
  getYadoBackendHost,
  getSearchParams,
  validateSearchParams,
  reloadPageWithoutSearchParams,
  makeRoomName,
  simpleFormat,
  isImageJalanNoPhoto,
  markdownLinkToAHref,
  getTranslatedXPeople,
  getTranslatedOnePerson,
  getTranslatedLiftTicket,
  getTranslatedRental,
  getTranslatedDirectBus,
  countPeople,
  getTranslatedHaveBreakfast,
  getTranslatedHaveDinner,
  boolStrToBool,
  getTranslatedHaveOpenAirBath,
  countStayDays,
  extractRoomIdFromRoomPlanId,
} from '../helper/accommodation_helper';
import ApiClient from './api_client/accommodation_api_client';
import { setPlanIconTexts } from './plan_icon_texts';
import { setupSearchForm, getFormParams } from './search_form';
import { loadPlanModal, initAccommodationPlanModal } from './accommodation_plan';
import { ICurrency } from '../../ShoppingCart/types';

const filteredValues = new Set();

// 詳細取得の場合、gonにyadoId（jxxxxxx）が必要
export function initAccommodationDetail() {
  setupSearchForm(onClickSearchButton);
  searchPlans();
  addEventListenerSwitchingAccordion();
  addEventListenerClickTabs();
  initGmaps();
  initAccommodationPlanModal();

  const $ = (window as any).jQuery;

  $('.js-plan-filter').click((event) => {
    const filterVal = $(event.target).attr('data-filter');

    if ($(event.target).hasClass('active')) {
      filteredValues.delete(filterVal);
      $(event.target).removeClass('active');
      $(`.js-plan-filter-disable-button[data-disable-filter="${filterVal}"]`).remove();
    } else {
      filteredValues.add(filterVal);
      $(event.target).addClass('active');

      const disableButton = createPlanFilterDisableButton();
      disableButton.find('.chip_txt').text($(event.target).text());
      disableButton.attr('data-disable-filter', filterVal);
      disableButton.appendTo($('#js-plan-filter-disable-buttons'));
      disableButton.click((disableButtonEvent) => {
        filteredValues.delete(filterVal);
        $(event.target).removeClass('active');
        $(disableButtonEvent.currentTarget).remove();
        showHidePlanItem();
        showHideRoomItem();
        updateRoomLowestPrice();
      });
      disableButton.show();
    }

    showHidePlanItem();
    showHideRoomItem();
    updateRoomLowestPrice();
  });

}

function initGmaps() {
  const gon = (window as any).gon;
  const google = (window as any).google;

  if (gon.yado && !inChinaIcpHost()) {
    const latlng = new google.maps.LatLng(gon.yado.latitude, gon.yado.longitude);
    const map = new google.maps.Map(
      document.getElementById('accommodation-gmap'),
      {
        center: latlng,
        zoom: 12,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      }
    );
    const marker = new google.maps.Marker({
      position: latlng,
      map: map,
    });
    const infoWindow = new google.maps.InfoWindow({
      content: `<div>${gon.yado.name || gon.yado.localizedName}</div>`,
    });
    marker.addListener('click', () => {
      infoWindow.open(map, marker);
    });
  }
}

function showHidePlanItem() {
  const $ = (window as any).jQuery;

  $('.js-plan-item').each((index, elem) => {
    const show = Array.from(filteredValues).every(val => {
      return boolStrToBool($(elem).attr(`data-${val}`))
    });
    if (show) {
      $(elem).show();
    } else {
      $(elem).hide();
    }
  });
  if (filteredValues.size === 0) {
    $('.js-plan-item').each((index, elem) => {
      $(elem).show();
    });
  }
}

function showHideRoomItem() {
  const $ = (window as any).jQuery;

  $('.js-room-item').each((index, elem) => {
    const visiblePlanItems = $(elem).find('.js-plan-item').toArray().filter(planItemElem => {
      return $(planItemElem).css('display') !== 'none';
    });
    if (visiblePlanItems.length === 0) {
      $(elem).hide();
    } else {
      $(elem).show();
    }
  });
}

function updateRoomLowestPrice() {
  const $ = (window as any).jQuery;

  $('.js-room-item').each((index, elem) => {
    const visiblePlanItems = $(elem).find('.js-plan-item').toArray().filter(planItemElem => {
      return $(planItemElem).css('display') !== 'none';
    });
    if (visiblePlanItems.length >= 1) {
      const planPriceElem = $(visiblePlanItems[0]).find('.js-plan-price')
      // 今は安い順なので、最初のプランの価格が部屋のうちで最安
      const lowestPriceWithComma = planPriceElem[0].firstChild.textContent;
      const lowestPrice = planPriceElem.attr('data-plan-price');
      $(elem).find('.js-room-price').text(`${priceWithCommas(lowestPriceWithComma)} ~`);
      $(elem).find('.js-room-price').attr('data-room-price', `${priceWithCommas(lowestPrice)}`);
    }
  });
}

function addEventListenerClickTabs() {
  const $ = (window as any).jQuery;
  $('#js-tab-plan-list').click(() => {
    scrollToPlanItems();
  });
  $('#js-tab-detail-info').click(() => {
    scrollToDetailInfo();
  })
  $('#js-tab-ski-resort-access').click(() => {
    scrollToSkiResortAccess();
  });
}

function addEventListenerSwitchingAccordion() {
  const $ = (window as any).jQuery;

  $('.i-accordion').on('show.bs.collapse', function (n) {
    $(n.target).siblings('.panel-heading').find('.panel-title i')
      .addClass('fa-arrow-circle-up')
      .removeClass('fa-arrow-circle-down');
  });
  $('.i-accordion').on('hide.bs.collapse', function (n) {
    $(n.target).siblings('.panel-heading').find('.panel-title i')
      .addClass('fa-arrow-circle-down')
      .removeClass('fa-arrow-circle-up');
  });
}

export function searchPlans() {
  const gon = (window as any).gon;
  const ua = (navigator as any).userAgent;

  const apiClient = new ApiClient({ host: getYadoBackendHost() });
  const searchParams = getSearchParams();

  if (!validateSearchParams(searchParams)) {
    reloadPageWithoutSearchParams();
    return;
  }

  let yadoId = gon.yadoId;
  if (yadoId != null && !isbot(ua)) {
    hideErrorMessages();
    emptyRoomItems();
    showPlanItemSpinner();
    hidePlans()
    apiClient.fetchYadoPlanItems(searchParams, yadoId, onCompletedFetchYadoPlanItems, onFailedFetchYadoPlanItems);
  }
}

function onCompletedFetchYadoPlanItems(data: any) {
  if (data && data.yado && data.yado.roomPlans) {
    const roomPlansWithoutDinnerSelectable = excludeDinnerSelectablePlans(data.yado.roomPlans);
    hidePlanItemSpinner();
    displayPlanItems(roomPlansWithoutDinnerSelectable);
    showHidePlanFilterButton(roomPlansWithoutDinnerSelectable);
    resetFilter();
  }
}

// スノヤドでは夕食選べるプランを非表示にする
function excludeDinnerSelectablePlans(roomPlans) {
  // 夕食IDが1つ以下なら表示OK
  return roomPlans.filter(rp => rp.plan.dinnerIds.length <= 1);
}

function onFailedFetchYadoPlanItems(status: number, responseJSON: Object) {
  hidePlanItemSpinner();

  if (status === 404) {
    showNotFoundMessage();
  } else if (status === 429) {
    showTooManyErrorMessage();
  } else {
    showErrorMessage();
  }
}

function onClickSearchButton() {
  const gon = (window as any).gon;

  searchPlans();
  scrollToPlanItems();
  const searchParams = getSearchParams();
}

function scrollToPlanItems() {
  const $ = (window as any).jQuery;

  $('html, body').animate({
    scrollTop: $("#js-plans-container").offset().top - 230,
  }, 500);
}

function scrollToDetailInfo() {
    const $ = (window as any).jQuery;

  $('html, body').animate({
    scrollTop: $("#js-detail-info").offset().top - 20,
  }, 500);
}

function scrollToSkiResortAccess() {
    const $ = (window as any).jQuery;

  $('html, body').animate({
    scrollTop: $("#js-ski-resort-access").offset().top - 20,
  }, 500);
}

function displayPlanItems(roomPlans) {
  const gon = (window as any).gon;
  const $ = (window as any).jQuery;
  emptyRoomItems();

  if (roomPlans.length === 0) {
    showNotFoundMessage();
    return;
  }
  hideErrorMessages();

  const peopleCount = getPeopleCount();

  const sortedRoomPlans = roomPlans.sort((roomPlanA, roomPlanB) => {
    return roomPlanA.plan.totalAmountExcludingTax - roomPlanB.plan.totalAmountExcludingTax;
  })

  const roomPlansObj = {}
  sortedRoomPlans.forEach(roomPlan => {
    const roomId = extractRoomIdFromRoomPlanId(roomPlan.roomPlanId);
    if (roomPlansObj[roomId] == null) {
      roomPlansObj[roomId] = [roomPlan];
    } else {
      roomPlansObj[roomId].push(roomPlan)
    }
  })

  Object.keys(roomPlansObj).forEach((planIdKey, index) => {
    const roomPlans = roomPlansObj[planIdKey];
    const room = roomPlans[0].room;
    const roomItemElem = createRoomItem();
    roomItemElem.attr('id', `js-room-${planIdKey}`);
    roomItemElem.attr('data-room-first-image', room.images[0] || '');
    const exchangeRate = Number($('#current-exchange-rate').val());
    const localCurrency :ICurrency = JSON.parse($('#local-currency').val());

    if (gon.yado) {
      if (gon.yado.roomFacility) {
        if (gon.yado.roomFacility.freeWifi) {
          roomItemElem.find('.js-room-icons-on-image').append($('<i>', { class: 'ico_wifi_white' }));
        }
        if (gon.yado.roomFacility.bath) {
          roomItemElem.find('.js-room-icons').append($('<li>').append($('<i>', { class: 'ico_hotel ico_clean'})));
        }
        if (gon.yado.roomFacility.airConditioner) {
          roomItemElem.find('.js-room-icons').append($('<li>').append($('<i>', { class: 'ico_hotel ico_cool'})));
        }
      }
    }

    if (room.smoking) {
      roomItemElem.find('.js-room-icons').append($('<li>').append($('<i>', { class: 'ico_hotel ico_smoke'})));
    }

    roomItemElem.find('.js-open-plans').attr('href', `#js-room-${planIdKey}-plans`);
    roomItemElem.find('.js-plan-items').attr('id', `js-room-${planIdKey}-plans`);

    const roomName = makeRoomName(room);
    roomItemElem.find('.js-room-name').text(roomName);
    roomItemElem.find('.js-room-image').attr('src', room.images[0]);
    roomItemElem.find('.js-room-price').text(`${priceWithCommas(roomPlans[0].plan.totalAmountExcludingTax * exchangeRate)} ~`);
    roomItemElem.find('.js-room-price-jpy').text(`${addNumberDelimiterForPrice(Math.round(roomPlans[0].plan.totalAmountExcludingTax))} ~`);
    roomItemElem.find('.js-room-price').attr('data-room-price', roomPlans[0].plan.totalAmountExcludingTax);
    roomItemElem.appendTo($('#js-room-items'));
    roomItemElem.show();

    roomPlans.forEach(roomPlan => {
      const planItemElem = createPlanItem();
      const planName = roomPlan.plan.name || roomName;
      planItemElem.find('.js-plan-name').text(planName);

      if (peopleCount === 1) {
        planItemElem.find('.js-plan-price').html(`${priceWithCommas(roomPlan.plan.totalAmountExcludingTax * exchangeRate)}<span>/${getTranslatedOnePerson()}</span>`);
        planItemElem.find('.js-plan-price-jpy').html(`${addNumberDelimiterForPrice(Math.round(roomPlan.plan.totalAmountExcludingTax))}<span>/${getTranslatedOnePerson()}</span>`);
      } else {
        planItemElem.find('.js-plan-price').html(`${priceWithCommas(roomPlan.plan.totalAmountExcludingTax * exchangeRate)}<span>/${getTranslatedXPeople(peopleCount)}</span>`);
        planItemElem.find('.js-plan-price-jpy').html(`${addNumberDelimiterForPrice(Math.round(roomPlan.plan.totalAmountExcludingTax))}<span>/${getTranslatedXPeople(peopleCount)}</span>`);
      }
      planItemElem.find('.js-plan-price').attr('data-plan-price', roomPlan.plan.totalAmountExcludingTax);
      planItemElem.find('.js-plan-tax-included-price').text(`${localCurrency.code} ${priceWithCommas(roomPlan.plan.totalAmountIncludingTax * exchangeRate)}`);
      planItemElem.find('.js-plan-tax-included-price-jpy').text(` (JPY ${addNumberDelimiterForPrice(Math.round(roomPlan.plan.totalAmountIncludingTax))})`);

      if (roomPlan.plan.breakfast) {
        planItemElem.find('.js-plan-feature-tags').append($('<li>', { text: `#${getTranslatedHaveBreakfast()}` }))
        planItemElem.find('.js-plan-meal').show();
      }

      if (roomPlan.plan.dinner) {
        planItemElem.find('.js-plan-feature-tags').append($('<li>', { text: `#${getTranslatedHaveDinner()}` }))
        planItemElem.find('.js-plan-meal').show();
      }

      if (roomPlan.plan.hasLiftTicket) {
        planItemElem.find('.js-plan-feature-tags').append($('<li>', { text: `#${getTranslatedLiftTicket()}` }))
      }

      if (roomPlan.plan.hasRental) {
        planItemElem.find('.js-plan-feature-tags').append($('<li>', { text: `#${getTranslatedRental()}` }))
      }

      if (roomPlan.plan.hasShuttleBusFromTokyo) {
        planItemElem.find('.js-plan-feature-tags').append($('<li>', { text: `#${getTranslatedDirectBus()}` }))
      }

      if (roomPlan.room.openAirBath) {
        planItemElem.find('.js-plan-feature-tags').append($('<li>', { text: `#${getTranslatedHaveOpenAirBath()}` }))
      }

      if (gon.yado) {
        if (gon.yado.roomFacility.bath) {
          planItemElem.find('.js-plan-bath').show();
        }
        if (gon.yado.roomFacility.airConditioner) {
          planItemElem.find('.js-plan-air-conditioner').show();
        }
      }

      const featureTags = createPlanFeatureTags(roomPlan.plan.featureTag);
      featureTags.forEach(t => {
        planItemElem.find('.js-plan-feature-tags').append($('<li>', { text: t }))
      });

      // 送迎手配は全プラン対応
      planItemElem.attr('data-arranging-pickup', 'true');

      if (roomPlan.plan.breakfast) {
        planItemElem.attr('data-breakfast', 'true');
      }
      if (roomPlan.plan.dinner) {
        planItemElem.attr('data-dinner', 'true');
      }
      if (roomPlan.plan.hasLiftTicket) {
        planItemElem.attr('data-lift-ticket', 'true');
      }
      if (roomPlan.plan.hasRental) {
        planItemElem.attr('data-rental', 'true');
      }
      if (roomPlan.plan.hasShuttleBusFromTokyo) {
        planItemElem.attr('data-shuttle-bus-from-tokyo', 'true');
      }
      if (roomPlan.plan.familyFriendly) {
        planItemElem.attr('data-family-friendly', 'true');
      }
      if (roomPlan.room.openAirBath) {
        planItemElem.attr('data-open-air-bath', 'true');
      }
      if (roomPlan.room.smoking) {
        planItemElem.find('.js-plan-smoke').show();
      }
      if (roomPlan.room.smoking === false) {
        planItemElem.attr('data-non-smoking', 'true');
        planItemElem.find('.js-plan-non-smoke').show();
      }

      setLink(roomPlan, planItemElem.find('.link-plan'));
      planItemElem.attr('data-room-plan-id', roomPlan.roomPlanId);

      planItemElem.appendTo($(`#js-room-${planIdKey}-plans`));
      planItemElem.show();
    });
  });
  addEventListenerClickOpenPlanModalButton();


  // 部屋を安い順にソートする
  const sortedRoomItems = $('.js-room-item').sort((a, b) => {
    if (
      Number($(a).find('.js-room-price').attr('data-room-price')) > Number($(b).find('.js-room-price').attr('data-room-price'))
    ) {
      return 1;
    } else {
      return -1;
    }
  });
  $('#js-room-items').empty();
  $('#js-room-items').append(...sortedRoomItems);

  // 折りたたみの矢印アイコン切り替えのイベントリスナー再登録
  addEventListenerSwitchingAccordion();

  // 2部屋目まで折りたたみをオープン表示
  $('.js-plan-items').each((index, elem) => {
    if (index <= 1) {
      $(elem).collapse('toggle');
    }
  });
}

function hideErrorMessages() {
  hideNotFoundMessage();
  hideTooManyErrorMessage();
  hideErrorMessage();
}

function showNotFoundMessage() {
  const $ = (window as any).jQuery;
  $('.js-show-when-not-found-plans').show();
}

function hideNotFoundMessage() {
  const $ = (window as any).jQuery;
  $('.js-show-when-not-found-plans').hide();
}

function showTooManyErrorMessage() {
  const $ = (window as any).jQuery;
  $('.js-show-when-too-many-error-occurred-plans').show();
}

function hideTooManyErrorMessage() {
  const $ = (window as any).jQuery;
  $('.js-show-when-too-many-error-occurred-plans').hide();
}

function showErrorMessage() {
  const $ = (window as any).jQuery;
  $('.js-show-when-error-occurred-plans').show();
}

function hideErrorMessage() {
  const $ = (window as any).jQuery;
  $('.js-show-when-error-occurred-plans').hide();
}

function showHidePlanFilterButton(roomPlans) {
  const $ = (window as any).jQuery;

  const showLiftTicket = roomPlans.some(roomPlan => roomPlan.plan.hasLiftTicket);
  const showRental = roomPlans.some(roomPlan => roomPlan.plan.hasRental);
  const showShuttleBusFromTokyo = roomPlans.some(roomPlan => roomPlan.plan.hasShuttleBusFromTokyo);
  const showFamilyFriendly = roomPlans.some(roomPlan => roomPlan.plan.familyFriendly);
  const showBreakfast = roomPlans.some(roomPlan => roomPlan.plan.breakfast);
  const showDinner = roomPlans.some(roomPlan => roomPlan.plan.dinner);
  const showPrivateOpenAirBath = roomPlans.some(roomPlan => roomPlan.room.openAirBath);
  const showNonSmoking = roomPlans.some(roomPlan => (roomPlan.room.smoking === false));

  if (showLiftTicket) {
    $('.js-plan-filter[data-filter="lift-ticket"]').show();
  } else {
    $('.js-plan-filter[data-filter="lift-ticket"]').hide();
  }
  if (showRental) {
    $('.js-plan-filter[data-filter="rental"]').show();
  } else {
    $('.js-plan-filter[data-filter="rental"]').hide();
  }
  if (showShuttleBusFromTokyo) {
    $('.js-plan-filter[data-filter="shuttle-bus-from-tokyo"]').show();
  } else {
    $('.js-plan-filter[data-filter="shuttle-bus-from-tokyo"]').hide();
  }
  if (showFamilyFriendly) {
    $('.js-plan-filter[data-filter="family-friendly"]').show();
  } else {
    $('.js-plan-filter[data-filter="family-friendly"]').hide();
  }
  if (showBreakfast) {
    $('.js-plan-filter[data-filter="breakfast"]').show();
  } else {
    $('.js-plan-filter[data-filter="breakfast"]').hide();
  }
  if (showDinner) {
    $('.js-plan-filter[data-filter="dinner"]').show();
  } else {
    $('.js-plan-filter[data-filter="dinner"]').hide();
  }
  if (showPrivateOpenAirBath) {
    $('.js-plan-filter[data-filter="open-air-bath"]').show();
  } else {
    $('.js-plan-filter[data-filter="open-air-bath"]').hide();
  }
  if (showNonSmoking) {
    $('.js-plan-filter[data-filter="non-smoking"]').show();
  } else {
    $('.js-plan-filter[data-filter="non-smoking"]').hide();
  }
}

function resetFilter() {
  const $ = (window as any).jQuery;
  filteredValues.clear();
  $('#js-plan-filter-disable-buttons').empty();
  $('.js-plan-filter.active').removeClass('active');
}


function getPeopleCount() {
  const $ = (window as any).jQuery;

  const params = getFormParams();
  return countPeople(params.rooms as string[]);
}

function setLink(roomPlan, linkElem) {
  const $ = (window as any).jQuery;

  const form = $("#accommodations-search-form");

  linkElem.attr('href', `${location.pathname}/plans/${roomPlan.roomPlanId}/order/new?${form.serialize()}`);
}

function addEventListenerClickOpenPlanModalButton() {
  const $ = (window as any).jQuery;

  $(document).on('click', '.link-plan-modal', (event) => {
    event.stopPropagation();
    event.preventDefault();

    const searchParams = getSearchParams();
    const planItemElem = $(event.currentTarget).parents('.js-plan-item');
    const roomPlanId = planItemElem.attr('data-room-plan-id');

    $('#plan_detail_modal').modal('show');
    loadPlanModal(roomPlanId, searchParams);
  });
}

function hidePlanItemSpinner() {
  const $ = (window as any).jQuery;

  $('.js-plan-item-spinner').hide();
}

function showPlanItemSpinner() {
  const $ = (window as any).jQuery;

  $('.js-plan-item-spinner').show();
}

function hidePlans() {
  const $ = (window as any).jQuery;

  $('#js-plan-items').hide();
}

function emptyRoomItems() {
  const $ = (window as any).jQuery;

  $('#js-room-items').empty();
}

function createPlanItem() {
  const $ = (window as any).jQuery;

  const planItemElem = $('#js-plan-item-template').clone(true);
  planItemElem.removeAttr('id', 'js-plan-item-template');
  planItemElem.addClass('js-plan-item');
  return planItemElem;
}

function createRoomItem() {
  const $ = (window as any).jQuery;

  const roomItemElem = $('#js-room-item-template').clone(true);
  roomItemElem.removeAttr('id', 'js-room-item-template');
  roomItemElem.addClass('js-room-item');
  return roomItemElem;
}

function createPlanFilterDisableButton() {
  const $ = (window as any).jQuery;

  const filterDisableButtonElem = $('#js-plan-filter-disable-button-template').clone(true);
  filterDisableButtonElem.removeAttr('id', 'js-plan-filter-disable-button-template');
  filterDisableButtonElem.addClass('js-plan-filter-disable-button');
  return filterDisableButtonElem;
}

function createPlanFeatureTags(featureTag: string) {
  if (featureTag == null || featureTag === '') return [];
  const featureTags = featureTag.split(',').map(t => `#${t}`);
  return featureTags;
}
